'use client';

import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, TrendingDown } from 'lucide-react';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  trend?: number;
  subtitle?: string;
  gradient?: boolean;
}

export function StatsCard({ title, value, icon, trend, subtitle, gradient }: StatsCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      className={`rounded-xl p-5 shadow-sm border ${
        gradient ? 'text-white border-transparent' : 'bg-white border-admin-border'
      }`}
      style={
        gradient ? { background: 'linear-gradient(155deg, #101f6e 0%, #112793 100%)' } : undefined
      }
    >
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <p
            className={`text-xs font-medium uppercase tracking-wider ${
              gradient ? 'text-admin-cyan-light/80' : 'text-admin-text-secondary'
            }`}
          >
            {title}
          </p>
          <p className={`text-2xl font-bold ${gradient ? 'text-white' : 'text-admin-text'}`}>{value}</p>
          {subtitle && (
            <p className={`text-xs ${gradient ? 'text-admin-cyan-light/70' : 'text-admin-text-secondary'}`}>
              {subtitle}
            </p>
          )}
        </div>
        <div className={`p-2.5 rounded-lg ${gradient ? 'bg-white/10' : 'bg-admin-cyan-light/30'}`}>
          {icon}
        </div>
      </div>
      {trend !== undefined && (
        <div className="mt-3 flex items-center gap-1 text-xs font-medium">
          {trend >= 0 ? (
            <TrendingUp className="h-3.5 w-3.5 text-admin-success" />
          ) : (
            <TrendingDown className="h-3.5 w-3.5 text-destructive" />
          )}
          <span className={trend >= 0 ? 'text-admin-success' : 'text-destructive'}>
            {trend >= 0 ? '+' : ''}
            {trend}%
          </span>
          <span className={gradient ? 'text-white/60' : 'text-admin-text-secondary'}>vs mês anterior</span>
        </div>
      )}
    </motion.div>
  );
}

